import { NoticeTypes, SelectTypes } from '@genial/components';
import { ColorTypes } from '@genial/design-tokens';
import { ReportingEnumsProfitabilityReportMarkingTypeEnum } from '@genial/services/dist/models';

export const profitabilityReportMarkingTypeEnum = {
  Market: 'Market',
  Curve: 'Curve',
  CustomerPortfolioDefault: 'CustomerPortfolioDefault',
} as const satisfies Record<string, ReportingEnumsProfitabilityReportMarkingTypeEnum>;

export type AssetIntervalFilter = {
  label: string;
  labelMobile: string;
  source: string;
  lessMonths: number;
};
export type AssetCompareOption = { label: string; value: string; color: ColorTypes.Option };

export const assetIntervalFilters: AssetIntervalFilter[] = [
  {
    label: '3 meses',
    labelMobile: '3M',
    source: 'periodDatapoints',
    lessMonths: 3,
  },
  { label: '6 meses', labelMobile: '6M', source: 'periodDatapoints', lessMonths: 6 },
  { label: '12 meses', labelMobile: '12M', source: 'periodDatapoints', lessMonths: 12 },
  { label: 'Desde o início', labelMobile: 'Máximo', source: 'allTimeDatapoints', lessMonths: 0 },
];

export const assetCompareOptions: AssetCompareOption[] = [
  {
    label: '%asset',
    value: 'Asset',
    color: 'brand.primary.principal',
  },
  {
    label: 'CDI',
    value: 'InterbankRate',
    color: 'linechart.bench1',
  },
  {
    label: 'Poupança',
    value: 'CheckingsAccounts',
    color: 'linechart.bench2',
  },
  {
    label: 'IBOV',
    value: 'BovespaIndex',
    color: 'linechart.bench3',
  },
  {
    label: 'IPCA',
    value: 'ConsumerPriceIndex',
    color: 'linechart.bench4',
  },
];

export const noticeRequiredAttentionSection = {
  FixedIncome: [
    {
      text: 'Atenção: ',
      variant: 'bold',
    },
    {
      text: 'O gráfico de Renda Fixa exibe apenas informações com base na marcação a mercado. ',
      variant: 'regular',
    },
  ],
} as Record<string, NoticeTypes.TextObject[]>;

export const profitabilityTypeOptions: SelectTypes.Option[] = [
  {
    value: profitabilityReportMarkingTypeEnum.Market,
    label: 'Mercado',
  },
  {
    value: profitabilityReportMarkingTypeEnum.Curve,
    label: 'Curva',
  },
  {
    value: profitabilityReportMarkingTypeEnum.CustomerPortfolioDefault,
    label: 'Padrão da carteira do cliente',
  },
];

export const monthsOptions: SelectTypes.Option[] = [
  {
    value: '1',
    label: 'Janeiro',
  },
  {
    value: '2',
    label: 'Fevereiro',
  },
  {
    value: '3',
    label: 'Março',
  },
  {
    value: '4',
    label: 'Abril',
  },
  {
    value: '5',
    label: 'Maio',
  },
  {
    value: '6',
    label: 'Junho',
  },
  {
    value: '7',
    label: 'Julho',
  },
  {
    value: '8',
    label: 'Agosto',
  },
  {
    value: '9',
    label: 'Setembro',
  },
  {
    value: '10',
    label: 'Outubro',
  },
  {
    value: '11',
    label: 'Novembro',
  },
  {
    value: '12',
    label: 'Dezembro',
  },
];

export const initialProfitabilityType = profitabilityTypeOptions[2]
  .value as ReportingEnumsProfitabilityReportMarkingTypeEnum;

export const defaultAssetCompareOptions = [...assetCompareOptions];
export const chartTags = assetCompareOptions
  .map((item) => ({ [item.value]: item.label }))
  .reduce((acc, item) => ({ ...acc, ...item }), {});

export const buildYearOptions = (startYear: number, endYear: number): SelectTypes.Option[] =>
  Array.from({ length: endYear - startYear + 1 }, (_, index) => {
    const year = String(endYear - index);
    return { value: year, label: year };
  });
